import { Video } from '@desquared/wave-components-library';

export function VideoSection(props) {
  return <Video {...props} />;
}
